import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';
import { StackFilter, StackFilterDocument } from './types';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface CloneStackFilterParams {
  stackFilter: StackFilter;
  name: string;
}

const cloneStackFilter: MutationFunction<
  CloneStackFilterParams,
  CloneStackFilterParams
> = async (args) => {
  if (isMockServices())
    return await mock(_mockStackFilter(args), { delay: 4000, failureRate: 1 });
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const currentStackFilter = await authTokenHttp<{
    filter: {
      configuration: {
        orderedDocumentTypeIds: StackFilterDocument[];
      };
      name: string;
      id: string;
      isOrganization: boolean;
    };
  }>(`/search-filters/${args.stackFilter.id}`, {
    method: 'GET',
  });
  if (!currentStackFilter.data) throw new Error('Failed to get stack filter');
  const stackFilter = currentStackFilter.data;

  const response = await authTokenHttp<CloneStackFilterParams>(
    `/search-filters`,
    {
      method: 'POST',
      body: {
        name: args.name,
        type: 'stack',
        visibility: 'private',
        configuration: {
          orderedDocumentTypeIds:
            stackFilter.filter.configuration.orderedDocumentTypeIds,
        },
      },
    },
  );
  if (response.data) return response.data;
  throw new Error('Failed to set stack filter');
};

export default cloneStackFilter;

const _mockStackFilter = (
  stackFilter: CloneStackFilterParams & { stackFilterId?: string },
) => {
  return {
    id: crypto.randomUUID(),
    ...stackFilter,
  };
};
